module.exports = __webpack_public_path__ + "img/wog.2c7c51ce.jpg";